var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Duration",
    role: "img",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Duration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,0C22.3858,0,0,22.3858,0,50s22.3858,50,50,50s50-22.3858,50-50C99.9708,22.3978,77.6021,0.0292,50,0z  M70.9612,70.9524c-1.2185,1.2154-3.1907,1.2154-4.4092,0L47.7866,52.2046c-0.575-0.5922-0.8921-1.388-0.8818-2.2134V21.8695 c0-1.7265,1.3996-3.1261,3.1261-3.1261c1.7265,0,3.1261,1.3996,3.1261,3.1261v26.8254l17.8307,17.8307 c1.2127,1.2254,1.2025,3.2019-0.023,4.4147c-0.0041,0.0041-0.0082,0.0081-0.0123,0.0121H70.9612z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.bcbf5d126a2d011d9dc12464ff802d8c.svg";
export { ForwardRef as ReactComponent };